import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, Button, Grid } from '@mui/material';
import { useFieldArray } from 'react-hook-form';
import { FormInput } from '~/components/FormComponents/FormInput';
import { commonStyles } from '~/theme/styles/commonStyles';
import { styles } from '../../../../styles';

interface ICommentContragentInfoProps {
  answerIndex: number;
  explanationIndex: number;
}

export const CommentContragentInfo = ({
  answerIndex,
  explanationIndex,
}: ICommentContragentInfoProps) => {
  const { fields, remove, append } = useFieldArray({
    name: `explanation.${explanationIndex}.answers.${answerIndex}.comments`,
  });
  return (
    <Grid container sx={{ pl: 1 }}>
      {fields?.map((comment, index) => (
        <Grid key={comment.id} size={{ md: 6, sm: 12 }} sx={{ display: 'flex' }}>
          <Box>
            <FormInput
              variant="standard"
              name={`explanation.${explanationIndex}.answers.${answerIndex}.comments.${index}.RNOKPP`}
              placeholder="РНОКПП або ЄДРПОУ"
              aria-label="RNOKPP or EDRPOU"
              fullWidth
              errorTouchedOnly
              sx={styles.tableInput}
            />
            <FormInput
              variant="standard"
              name={`explanation.${explanationIndex}.answers.${answerIndex}.comments.${index}.fullName`}
              placeholder="ПІБ або назва"
              aria-label="Full name or company name"
              fullWidth
              errorTouchedOnly
              sx={styles.tableInput}
            />
          </Box>
          <Box sx={styles.contragentBtnsContainer}>
            <Button
              onClick={() => append({ RNOKPP: '', fullName: '' })}
              sx={commonStyles.actionButton}
            >
              <AddIcon sx={{ width: 16, height: 16 }} />
            </Button>
            {fields.length > 1 && (
              <Button onClick={() => remove(index)} sx={commonStyles.actionButton}>
                <RemoveIcon sx={{ width: 16, height: 16 }} />
              </Button>
            )}
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};
